<template>
<Loader v-if="loader" />
<Toast :group="page.notifica" position="bottom-center" />
<ConfirmDialog group="contact-edit">
  <template #message="slotProps">
    <div class="contact-edit-confirmation">
      <div class="flex align-items-center">
        <i class="pi pi-exclamation-triangle mr-3" aria-hidden="true"></i>
        <span>{{ slotProps.message.message }}</span>
      </div>

      <div v-if="slotProps.message.duplicateContacts && slotProps.message.duplicateContacts.length" class="duplicate-contacts-list">
        <section v-for="duplicate in slotProps.message.duplicateContacts" :key="duplicate.id" class="duplicate-contact-section">
          <div class="duplicate-contact-title">
            <span class="duplicate-contact-dialog-hand" aria-hidden="true">&#128073;</span>
            <strong>Contatto esistente #{{ duplicate.id }}</strong>
          </div>
          <div>{{ contactAddress(duplicate) }}</div>
          <div>Email: {{ duplicate.email || '(vuota)' }}</div>
          <div>PEC: {{ duplicate.pec || '(vuota)' }}</div>
          <div>Cellulare: {{ duplicate.cell || '(vuoto)' }}</div>
        </section>
      </div>

      <section v-if="slotProps.message.validationErrors && slotProps.message.validationErrors.length" class="contact-validation-section">
        <strong>Correggi i seguenti dati:</strong>
        <ul>
          <li v-for="error in slotProps.message.validationErrors" :key="error.field">{{ error.message }}</li>
        </ul>
      </section>

      <section v-if="slotProps.message.contactSummary && slotProps.message.contactSummary.length" class="contact-summary-section">
        <h5>Riepilogo contatto</h5>
        <div v-for="item in slotProps.message.contactSummary" :key="item.field" class="contact-summary-row">
          <strong>{{ item.label }}</strong>
          <span class="contact-summary-separator" aria-hidden="true">=&gt;</span>
          <span class="contact-summary-value">{{ item.value }}</span>
        </div>
      </section>

    </div>
  </template>
</ConfirmDialog>
<ContactImpactDialog
  v-model="contactDialog.visible"
  :header="contactDialog.header"
  :message="contactDialog.message"
  :changes="contactDialog.changes"
  :contact="contactDialog.contact"
  :contracts-header="contactDialog.contractsHeader"
  :confirmable="contactDialog.confirmable"
  @confirm="confirmContactImpact"
/>

  <SupplyRiepilogoSection
    v-if="data.item.id"
    entity-type="rappresentante"
    :cliente-id="data.item.id"
    :cliente-nome="data.item.info?.name"
    :pratiche-data="{ pratiche: [], pratiche_gestione: [] }"
  />

  <prime-accordion :multiple="true" :activeIndex="[0]" @tab-open="onRepresentativeTabOpen">
    <prime-accordion-tab header="Anagrafica">
      <div v-if="data.item.id">
        
        <div class="formgrid grid">
          <div class="field col-12 md:col-6">
            <label for="name">Nome Cognome</label>
            <prime-input-text
              id="name" 
              v-model="data.item.info.name" 
              type="text" 
              :disabled="!isInEdit" 
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-6">
            <label for="codfis">Codice Fiscale</label>
            <prime-input-text
              id="codfis" 
              v-model="data.item.info.codfis" 
              type="text" 
              :disabled="!isInEdit" 
              class="inputfield w-full"
            />
          </div>

          <div class="field col-12 md:col-6">
            <label for="email">Email</label>
            <prime-input-text 
              id="email" 
              v-model="data.item.info.email" 
              type="text" 
              :disabled="!isInEdit" 
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-6">
            <label for="pec">PEC</label>
            <prime-input-text 
              id="pec" 
              v-model="data.item.info.pec" 
              type="text" 
              :disabled="!isInEdit" 
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12">
            <label for="note">Note</label>
            <prime-textarea 
              id="note" 
              v-model="data.item.info.note" 
              :disabled="!isInEdit" 
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12">
            <p> <small>Pod in fornitura: {{data.item.n_pdps.pod}}</small></p>
            <p><small>Pdr in fornitura: {{data.item.n_pdps.pdr}}</small></p>
            <p><small>Pdp in fornitura: {{data.item.n_pdps.pdr + data.item.n_pdps.pod}}</small></p>
          </div>
        </div>

        <div class="grid p-jc-end">
          <div 
            class="col-12 text-right"
            v-if="!isInEdit"
          >
            <prime-button 
              icon="pi pi-pencil" 
              class="p-button-rounded p-button-success mr-2" 
              @click="onEditInfo"
            />
          </div>

          <div 
            class="col-12 text-right"
            v-if="isInEdit"
          >
            <prime-button 
              icon="pi pi-times" 
              class="p-button-rounded p-button-danger mr-2" 
              @click="onAbortInfoEdit"
            />
            <prime-button 
              icon="pi pi-check" 
              class="p-button-rounded p-button-success mr-2" 
              @click="onUpdateInfo"
            />
          </div>
        </div>
        
      </div>
    </prime-accordion-tab>

    <prime-accordion-tab header="Contatti">
      
      <div v-if="data.item.id">
        <prime-data-table :value="data.item.contatti" v-model:editingRows="editingContactRows" editMode="row" dataKey="id" :rowClass="contactRowClass" @row-edit-save="onContactRowEditSave" @row-edit-init="onContactRowEditInit" @row-edit-cancel="onContactRowEditCancel" responsiveLayout="scroll">
          <prime-column v-if="!isContactRowEditing" field="id" header="ID" style="min-width: 10rem">
            <template #body="{ data }">
              <div class="contact-id-cell">
                <div class="contact-id-main">
                  <span v-if="isDuplicateContact(data)" class="duplicate-contact-badge" title="Contatto già esistente" aria-hidden="true">&#128073;</span>
                  <strong>#{{ data.id }}</strong>
                </div>
                <span v-if="data.duplicate_of" class="contact-duplicate-label">Duplicato di #{{ data.duplicate_of }}</span>
              </div>
            </template>
          </prime-column>
          <!-- <prime-column field="indirizzo_completo" header="Indirizzo" ></prime-column> -->
          <prime-column field="toponimo" header="Toponimo" >
            <template #body="{ data }">
              <div class="contact-toponimo-cell">
                <i
                  v-if="contactFieldError(data, 'toponimo')"
                  v-tooltip.top="contactFieldError(data, 'toponimo')"
                  class="pi pi-exclamation-triangle contact-validation-icon mr-2"
                  aria-label="Toponimo non conforme"
                ></i>
                <span>{{ data.toponimo }}</span>
              </div>
            </template>
            <template #editor="{ data, field }">
                <Dropdown v-model="data[field]" :options="toponimi" optionLabel="name" optionValue="name" filter placeholder="Seleziona toponimo" />
            </template>
          </prime-column>
          <prime-column field="indirizzo" header="Indirizzo" >
            <template #body="{ data }">
              <div class="contact-field-cell">
                <i v-if="contactFieldError(data, 'indirizzo')" v-tooltip.top="contactFieldError(data, 'indirizzo')" class="pi pi-exclamation-triangle contact-validation-icon mr-2" aria-label="Indirizzo non conforme"></i>
                <span>{{ data.indirizzo }}</span>
              </div>
            </template>
            <template #editor="{ data, field }">
                <InputText v-model="data[field]" />
            </template>
          </prime-column>
          <prime-column field="civico" header="Civico" >
            <template #body="{ data }">
              <div class="contact-field-cell">
                <i v-if="contactFieldError(data, 'civico')" v-tooltip.top="contactFieldError(data, 'civico')" class="pi pi-exclamation-triangle contact-validation-icon mr-2" aria-label="Civico non conforme"></i>
                <span>{{ data.civico }}</span>
              </div>
            </template>
            <template #editor="{ data, field }">
                <InputText v-model="data[field]" />
            </template>
          </prime-column>
          <prime-column field="cap" header="CAP" >
            <template #body="{ data }">
              <div class="contact-field-cell">
                <i v-if="contactFieldError(data, 'cap')" v-tooltip.top="contactFieldError(data, 'cap')" class="pi pi-exclamation-triangle contact-validation-icon mr-2" aria-label="CAP non conforme"></i>
                <span>{{ data.cap }}</span>
              </div>
            </template>
            <template #editor="{ data, field }">
              <div v-if="contactCapSettings(data).isWildcard" class="multicap-editor">
                <span class="multicap-prefix" title="Prefisso CAP del comune">{{ contactCapSettings(data).prefix }}</span>
                <InputText
                  :modelValue="contactCapSuffix(data)"
                  maxlength="2"
                  inputmode="numeric"
                  class="multicap-suffix"
                  @update:modelValue="updateMultiCapSuffix(data, $event)"
                />
              </div>
              <InputText v-else v-model="data[field]" :disabled="contactCapSettings(data).isFixed" />
            </template>
          </prime-column>
          <prime-column field="comune" header="Comune" :sortable="true">
            <template #body="{ data }">
              <div class="contact-field-cell">
                <i v-if="contactFieldError(data, 'comune')" v-tooltip.top="contactFieldError(data, 'comune')" class="pi pi-exclamation-triangle contact-validation-icon mr-2" aria-label="Comune non conforme"></i>
                <span>{{ data.comune }}</span>
              </div>
            </template>
            <template #editor="{ data }">
                <Dropdown v-model="data['cod_comune']" @change="onChangeComuneContact($event, data)" :options="comuni" optionLabel="name" optionValue="id" filter placeholder="Seleziona comune">
                </Dropdown>
            </template>
          </prime-column>
          <prime-column field="provincia" header="Provincia" >
            <template #body="{ data }">
              <div class="contact-field-cell">
                <i v-if="contactFieldError(data, 'provincia')" v-tooltip.top="contactFieldError(data, 'provincia')" class="pi pi-exclamation-triangle contact-validation-icon mr-2" aria-label="Provincia non conforme"></i>
                <span>{{ data.provincia }}</span>
              </div>
            </template>
          </prime-column>
          <prime-column field="email" header="Email" >
            <template #body="{ data }">
              <div class="contact-field-cell">
                <i v-if="contactFieldError(data, 'email')" v-tooltip.top="contactFieldError(data, 'email')" class="pi pi-exclamation-triangle contact-validation-icon mr-2" aria-label="Email non conforme"></i>
                <span>{{ data.email }}</span>
              </div>
            </template>
            <template #editor="{ data, field }">
                <InputText v-model="data[field]" />
            </template>
          </prime-column>
          <prime-column field="pec" header="PEC" >
            <template #body="{ data }">
              <div class="contact-field-cell">
                <i v-if="contactFieldError(data, 'pec')" v-tooltip.top="contactFieldError(data, 'pec')" class="pi pi-exclamation-triangle contact-validation-icon mr-2" aria-label="PEC non conforme"></i>
                <span>{{ data.pec }}</span>
              </div>
            </template>
            <template #editor="{ data, field }">
                <InputText
                  :modelValue="data[field]"
                  @update:modelValue="onContactPecChange(data, $event)"
                />
            </template>
          </prime-column>
          <prime-column field="fax" header="Fax" >
            <template #editor="{ data, field }">
                <InputText v-model="data[field]" />
            </template>
          </prime-column>
          <prime-column field="tel" header="Telefono" >
            <template #editor="{ data, field }">
                <InputText v-model="data[field]" />
            </template>
          </prime-column>
          <prime-column field="cell" header="Cellulare" >
            <template #body="{ data }">
              <div class="contact-field-cell">
                <i v-if="contactFieldError(data, 'cell')" v-tooltip.top="contactFieldError(data, 'cell')" class="pi pi-exclamation-triangle contact-validation-icon mr-2" aria-label="Cellulare non conforme"></i>
                <span>{{ data.cell }}</span>
              </div>
            </template>
            <template #editor="{ data, field }">
                <InputText v-model="data[field]" />
            </template>
          </prime-column>
          <prime-column v-if="data.item.supports_bypass_pec" header="Bypass PEC" style="min-width: 18rem">
            <template #body="{ data }">
              <span
                v-if="Number(data.bypass_pec) === 1"
                v-tooltip.top="data.motivazione_bypass_pec || 'Motivazione non disponibile'"
                class="flex align-items-center text-orange-500 font-medium"
              >
                <i class="pi pi-check-circle mr-2"></i>
                Attivo
              </span>
              <span v-else class="text-color-secondary">Non attivo</span>
            </template>
            <template #editor="{ data }">
              <div class="contact-pec-bypass-editor">
                <div
                  v-tooltip.top="hasContactValue(data.pec) ? 'Il bypass può essere attivato solo quando la PEC è vuota.' : ''"
                  class="flex align-items-center"
                >
                  <Checkbox
                    v-model="data.bypass_pec"
                    :binary="true"
                    :true-value="1"
                    :false-value="0"
                    :disabled="hasContactValue(data.pec)"
                    inputId="contact-bypass-pec"
                    @update:modelValue="onContactPecBypassChange(data, $event)"
                  />
                  <label for="contact-bypass-pec" class="ml-2">Attiva bypass</label>
                </div>
                <div v-if="isContactPecBypassActive(data)" class="mt-2">
                  <InputText
                    v-model="data.motivazione_bypass_pec"
                    class="w-full"
                    :class="{ 'p-invalid': !hasContactValue(data.motivazione_bypass_pec) }"
                    placeholder="Motivazione obbligatoria"
                  />
                  <small v-if="!hasContactValue(data.motivazione_bypass_pec)" class="p-error">
                    Inserisci la motivazione del bypass.
                  </small>
                </div>
              </div>
            </template>
          </prime-column>
          <prime-column v-if="!isContactRowEditing" header="Associazioni" :exportable="false" style="width: 6rem" bodyStyle="text-align:center">
            <template #body="{ data }">
              <prime-button
                v-if="(data.contratti && data.contratti.length) || (data.caricamenti && data.caricamenti.length)"
                icon="pi pi-eye"
                class="p-button-rounded p-button-info"
                v-tooltip.top="`Contratti: ${data.numero_contratti ?? data.contratti?.length ?? 0} · Caricamenti: ${data.numero_caricamenti ?? data.caricamenti?.length ?? 0}`"
                @click="openContactAssociations(data)"
              />
            </template>
          </prime-column>
          <prime-column v-if="!isContactRowEditing" field="numero_contratti_attivi" header="Contratti attivi" style="width: 7rem" bodyStyle="text-align:center">
            <template #body="{ data }">{{ data.numero_contratti_attivi ?? 0 }}</template>
          </prime-column>
          <prime-column style="width: 10%; min-width: 8rem" bodyStyle="text-align:center">
            <template #body="{ editorInitCallback }">
              <prime-button
                icon="pi pi-pencil"
                class="p-button-rounded p-button-text"
                aria-label="Modifica contatto"
                @click="editorInitCallback"
              />
            </template>
            <template #editor="{ data, editorSaveCallback, editorCancelCallback }">
              <div class="flex justify-content-center gap-2">
                <span v-tooltip.top="{ value: contactRowSaveDisabledTooltip(data), disabled: !isContactRowSaveDisabled(data) }">
                  <prime-button
                    icon="pi pi-check"
                    class="p-button-rounded p-button-text p-button-success"
                    aria-label="Salva modifiche contatto"
                    :disabled="isContactRowSaveDisabled(data)"
                    @click="editorSaveCallback"
                  />
                </span>
                <prime-button
                  icon="pi pi-times"
                  class="p-button-rounded p-button-text p-button-danger"
                  aria-label="Annulla modifica contatto"
                  @click="editorCancelCallback"
                />
              </div>
            </template>
          </prime-column>
        </prime-data-table>
      </div>

      <div class="flex justify-content-end mb-2">
        <prime-button @click="toggleNewContactForm" icon="pi pi-plus" class="p-button-rounded p-button-success mr-2"  style="margin-top:-8px"/>
        <!-- <prime-button @click="newContact.visible = !newContact.visible" icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2"  style="margin-top:-20px"/> -->
      </div>

      <div v-if="newContact.visible" class="formgrid grid mt-4">
        <div class="col-12"><h6>Nuovo contatto</h6></div>
        <div class="field col-12 md:col-6 lg:col-4">
            <label>Toponimo</label>
            <Dropdown v-model="newContact.toponimo" :options="toponimi" optionLabel="name" optionValue="name" :filter="true" placeholder="Seleziona toponimo" class="w-full" />
            <div v-show="validationErrors.newContact_toponimo && submitted" class="p-error">{{ validationErrors.newContact_toponimo }}</div>
        </div>
        <div class="field col-12 md:col-6 lg:col-4">
            <label>Indirizzo</label>
            <input  v-model="newContact.indirizzo" class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
            <div v-show="validationErrors.newContact_indirizzo && submitted" class="p-error">{{ validationErrors.newContact_indirizzo }}</div>
        </div>
        <div class="field col-12 md:col-6 lg:col-4">
            <label>Civico</label>
            <input  v-model="newContact.civico" class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
            <div v-show="validationErrors.newContact_civico && submitted" class="p-error">{{ validationErrors.newContact_civico }}</div>
        </div>
        <div class="field col-12 md:col-6 lg:col-4">
            <label>Comune</label>
            <Dropdown v-model="newContact.comune" @change="onChangeNewContactComune" :options="comuni" optionLabel="name" optionValue="id" :filter="true" dataKey="id" placeholder="Seleziona comune" class="w-full" />
            <div v-show="validationErrors.newContact_comune && submitted" class="p-error">{{ validationErrors.newContact_comune }}</div>
        </div>
        <div class="field col-12 md:col-6 lg:col-4">
            <label>CAP</label>
            <div v-if="contactCapSettings(newContact).isWildcard" class="multicap-editor w-full">
              <span class="multicap-prefix" title="Prefisso CAP del comune">{{ contactCapSettings(newContact).prefix }}</span>
              <InputText
                :modelValue="contactCapSuffix(newContact)"
                maxlength="2"
                inputmode="numeric"
                class="multicap-suffix flex-1"
                placeholder="00"
                @update:modelValue="updateMultiCapSuffix(newContact, $event)"
              />
            </div>
            <InputText
              v-else
              v-model="newContact.cap"
              :disabled="!contactCapSettings(newContact).comune || contactCapSettings(newContact).isFixed"
              class="w-full"
            />
            <div v-show="validationErrors.newContact_cap && submitted" class="p-error">{{ validationErrors.newContact_cap }}</div>
        </div>
        <div class="field col-12 md:col-6 lg:col-4">
            <label>Provincia</label>
            <InputText v-model="newContact.provincia" disabled class="w-full" />
            <div v-show="validationErrors.newContact_provincia && submitted" class="p-error">{{ validationErrors.newContact_provincia }}</div>
        </div>
        <div class="field col-12 md:col-6 lg:col-4">
            <label>Cellulare</label>
            <input v-model="newContact.cell" class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
            <div v-show="validationErrors.newContact_cell && submitted" class="p-error">{{ validationErrors.newContact_cell }}</div>
        </div>
        <div class="field col-12 md:col-6 lg:col-4">
            <label>Email</label>
            <input  v-model="newContact.email" class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
            <div v-show="validationErrors.newContact_email && submitted" class="p-error">{{ validationErrors.newContact_email }}</div>
        </div>
        <div class="field col-12 md:col-6 lg:col-4">
            <label>PEC</label>
            <input  v-model="newContact.pec" class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
            <div v-show="validationErrors.newContact_pec && submitted" class="p-error">{{ validationErrors.newContact_pec }}</div>
        </div>
        <div class="field col-12 md:col-6 lg:col-4">
            <label>Telefono</label>
            <input  v-model="newContact.tel" class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
        </div>
        <div class="col-12 flex justify-content-end ">
          <Button
            @click="addNewContact"
            :disabled="isNewContactSaveDisabled()"
            label="Aggiungi"
            icon="pi pi-plus"
            iconPos="right"
          />
        </div>
      </div>

    </prime-accordion-tab>

    <prime-accordion-tab header="Documentazione">
      <section v-if="cambioRappresentanteAvailable" class="representative-change-documents mb-3">
        <h5>Documento d'identità</h5>
        <p v-if="changeDocumentsLoading">Caricamento documenti...</p>
        <p v-else-if="changeDocumentsError" class="p-error">{{ changeDocumentsError }}</p>
        <p v-else-if="!identityDocuments.length">Nessun documento d'identità.</p>
        <div v-else class="flex flex-wrap gap-2">
          <div v-for="documento in identityDocuments" :key="documento.id" class="p-3 border-1 border-round surface-border">
            <div><strong>{{ documento.tipo_documento || `Documento ${documento.id}` }}</strong></div>
            <small>{{ documento.data_inserimento ? moment(documento.data_inserimento).format('DD/MM/YYYY, HH:mm') : '' }}</small>
            <prime-button class="block mt-2" label="Visualizza" icon="pi pi-eye" :disabled="changeDocumentOpening === documento.id" @click="openChangeDocument(documento)" />
          </div>
        </div>
      </section>
      <AccordionDocumentiNomina :available="cambioRappresentanteAvailable" :representative-id="data.item.id" />
      <prime-accordion>
        <prime-accordion-tab header="Aggiungi un nuovo file">
          <div class="formgrid grid form-documents">
             <div class="field col-12 md:col-3">
              <div class="button-wrapper">
                <span class="label">{{data.allegato.file.length == 0 ? 'Seleziona File' : (data.allegato.file.length == 1 ? data.allegato.file[0].name : data.allegato.file.length +' files')}}</span>
                <input id="upload" type="file" @change="handleFileUpload( $event )" accept="application/pdf,image/gif, image/jpeg, image/jpg,image/png" multiple/>
              </div>
              <div v-show="validationErrors.files && submitted" class="p-error">Campo richiesto.</div>
              <div v-show="validationErrors.type && submitted" class="p-error">Formato non consentito</div>
            </div>
            <div class="field col-12 md:col-3">
              <prime-dropdown class="inputfield w-full" v-model="data.allegato.tipo" :options="data.tipiAllegato" optionLabel="name" optionValue="id" placeholder="Seleziona tipologia..." />
              <div v-show="validationErrors.tipo && submitted" class="p-error">Campo richiesto.</div>
            </div>
            <div class="field col-12 md:col-3">
              <prime-textarea  class="inputfield w-full"  v-model="data.allegato.note" rows="1" placeholder="Inserisci note..."/>
            </div>
            <div class="field col-12 md:col-3">
              <prime-button @click="uploadDocumenti" class="w-full" label="Carica" icon="pi pi-upload" iconPos="right" />
            </div>
          </div>
        </prime-accordion-tab>

        <prime-accordion-tab header="File Caricati" v-if="data.item.allegati && data.item.allegati.length > 0">
            <prime-data-table :value="data.item.allegati" responsiveLayout="scroll">
              <prime-column field="name" header="File" :sortable="true" >
                <template #body="{data}">
                  <div v-if="data.name">
                    {{data.name.split('/').reverse()[0]}}
                  </div>
                </template>
              </prime-column>
              <prime-column field="tipo" header="Tipo" :sortable="true" ></prime-column>
              <prime-column field="date_creation" header="Data Caricamento" :sortable="true" ></prime-column>
              <prime-column :exportable="false">
                <template #body="{data}">
                  <Button  icon="pi pi-download" class="p-button-rounded p-button-success mr-2" @click="downloadDocumenti(data)" />
                </template>
              </prime-column>
              <prime-column :exportable="false">
                <template #body="{data}">
                  <Button  icon="pi pi-eye" class="p-button-rounded p-button-success mr-2" @click="openDocumenti(data)" />
                </template>
              </prime-column>
            </prime-data-table>
        </prime-accordion-tab>

        <prime-accordion-tab header="Documenti scansionati" v-if="data.item.scansioni && data.item.scansioni.length > 0">
            <prime-data-table :value="data.item.scansioni" responsiveLayout="scroll">
              <prime-column field="file" header="File" :sortable="true" ></prime-column>
              <prime-column field="mese" header="Mese" :sortable="true" ></prime-column>
              <prime-column field="anno" header="Anno" :sortable="true" ></prime-column>
              <prime-column :exportable="false">
                <template #body="{data}">
                  <Button  icon="pi pi-download" class="p-button-rounded p-button-success mr-2" @click="downloadScansioni(data)" />
                </template>
              </prime-column>
              <prime-column :exportable="false">
                <template #body="{data}">
                  <Button  icon="pi pi-eye" class="p-button-rounded p-button-success mr-2" @click="openScansioni(data)" />
                </template>
              </prime-column>
            </prime-data-table>
        </prime-accordion-tab>

      </prime-accordion>

    </prime-accordion-tab>

    <prime-accordion-tab>
      <template v-if="data.item.id" #header>
        <span>Pagamenti Clienti</span>&nbsp;<span>Totale:&nbsp;{{ currencyFormatter.format( data.item.pagamenti_clienti.importo_totale ) }}&nbsp;Da pagare:&nbsp;{{ currencyFormatter.format( data.item.pagamenti_clienti.importo_totale - data.item.pagamenti_clienti.importo_pagato ) }}</span>
      </template>

      <div v-if="data.item.id">
        <prime-data-table :value="data.item.pagamenti_clienti.dettagli" responsiveLayout="scroll">
          <prime-column field="ragsoc" header="Cliente" :sortable="true"></prime-column>
          <prime-column field="codfis" header="Codice Fiscale" ></prime-column>
          <prime-column field="piva" header="Partita IVA" ></prime-column>
          <prime-column header="Importo Fatture" >
            <template #body="{data}">
              {{ currencyFormatter.format( (data.importo !== null)? data.importo : 0 ) }}
            </template>
          </prime-column>
          <prime-column header="Importo Pagato" >
            <template #body="{data}">
              {{ currencyFormatter.format( (data.pagato !== null)? data.pagato : 0 ) }}
            </template>
          </prime-column>
          <prime-column header="Saldo" >
            <template #body="{data}">
              {{ currencyFormatter.format( (data.saldo !== null)? data.saldo : 0 ) }}
            </template>
          </prime-column>
        </prime-data-table>
      </div>

    </prime-accordion-tab>

    <prime-accordion-tab header="Prospetto Ciclo Pagamenti">
      <div class="formgrid grid ">
        <div class="field col-12 md:col-9">
            <label>Anno</label>
            <Calendar v-model="year_ciclo" :showIcon="true" view="year" dateFormat="yy" class="inputfield w-full" />
        </div>
        <div class="field col-12 md:col-3 flex align-items-end justify-content-center">
            <Button label="Esegui" class="w-full" @click="getProspettoCicloPagamenti" />
        </div>
      </div>
      <div>
        <prime-accordion>
            <prime-accordion-tab v-for="(elements, month) in cicloPayments" :key="month">
                <template #header>
                  <div class="flex justify-content-between flex-wrap w-full">
                    <div class="flex align-items-center justify-content-left flex-column">
                      <div> <i class="pi pi-calendar mx-2"></i> {{month}}</div>
                     <div> <small class="text-500"> {{cicloPayments[month].invoices.length}} fatture</small> </div>
                    </div>
                    <i></i>
                    <div class="text-left">
                      <small class="price"> <span class="text-500">Totale Fatture:</span>  {{formatCurrency(elements.tot_fatture)}}</small> -
                      <small class="price"> <span class="text-500">Totale Pagato: </span> {{formatCurrency(elements.tot_pagato)}}</small> -
                      <small class="price"> <span class="text-500">Totale Saldo:</span>  {{formatCurrency(elements.tot_saldo)}}</small> -
                      <small class="price"> <span class="text-500">Totale Contabili:</span>  {{formatCurrency(elements.tot_contabili)}}</small>
                    </div>
                  </div>
                </template>

              <prime-data-table :ref="`dt_${month}`" :value="elements.invoices" @row-dblclick="openDetail" :paginator="true" :rows="20" :filters="filters"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[10,20,50]" responsiveLayout="scroll"
                currentPageReportTemplate="{first} a {last} di {totalRecords}">
                <template #header>
                  <div class="flex justify-content-between flex-wrap">
                      <div class="flex align-items-center justify-content-center mb-2">
                        <span class="p-input-icon-left">
                            <i class="pi pi-search" />
                            <prime-input-text type="search" v-model="filters['global'].value" placeholder="Cerca..." />
                        </span>
                      </div>
                      <div class="flex align-items-center justify-content-center">
                        <prime-button icon="pi pi-external-link" label="Esporta" @click="exportCSV(month)" class="p-button-secondary" />
                      </div>
                  </div>
                </template>
                <template #empty>
                    <div class="text-center">Nessun dato trovato.</div>
                </template>
                <prime-column field="numero" header="N. Fattura" :sortable="true" />
                <prime-column field="periodo" header="Periodo" :sortable="true" />
                <prime-column field="" header="Fornitura" :sortable="true">
                  <template #body="{data}">
                    <div v-if="data.pod">
                      {{data.pod}}
                    </div>
                    <div v-else>
                      {{data.pdr}}
                    </div>
                  </template>
                </prime-column>
                <prime-column field="mese_fatturazione" header="Mese Fatturazione" :sortable="true">
                  <template #body="{data}">
                    {{moment(data.mese_fatturazione).format('DD-MM-YYYY')}}     
                  </template>
                </prime-column>
                <prime-column field="data_emissione" header="Data Emissione" :sortable="true">
                  <template #body="{data}">
                    {{moment(data.data_emissione).format('DD-MM-YYYY')}}     
                  </template>
                </prime-column>
                <prime-column field="data_scadenza" header="Data Scadenza" :sortable="true">
                  <template #body="{data}">
                      {{moment(data.data_scadenza).format('DD-MM-YYYY')}}     
                  </template>
                </prime-column>
                <prime-column field="totale_fattura" header="Totale Fattura" :sortable="true" />
                <prime-column field="pagato" header="Totale Pagato" :sortable="true" />
                <prime-column field="saldo" header="Totale Saldo" :sortable="true" />
                <prime-column field="importo_contabile" header="Importo Contabile" :sortable="true" />
                <prime-column field="type_pay" header="Tipo Pagamento" :sortable="true" />
                <prime-column field="cliente" header="Cliente" :sortable="true" />
                <prime-column field="codfis" header="C.Fiscale" :sortable="true" />
                <prime-column field="piva" header="P.Iva" :sortable="true" />
                <prime-column field="rappresentante" header="Rappresentante" :sortable="true" />
                <prime-column field="tot_kwh" header="Totale Kwh" :sortable="true" />
                <prime-column field="tipo_fatturato" header="Stima/Distributore" :sortable="true" />
                <!-- <prime-column style="min-width:200px">
                  <template #body="{data}">
                      <prime-button label="Crea Pagamento in arrivo" @click="openPaymentArrivingDialog(data)" class="payment-arriving p-button-outlined" />    
                  </template>
                </prime-column> -->

              </prime-data-table>
              
            </prime-accordion-tab> 
        </prime-accordion>
      </div>

    </prime-accordion-tab>

    <prime-accordion-tab header="Notifica" v-if="disabledFirebase_id">
        <div v-if="data.item.id">
          <div class="flex">
            <div class="field col-12 md:col-6">
              <div>
                <p>Ultimo accesso: {{ data.item.info.updated_at }}</p>
                <prime-input-text
                  id="name" 
                  v-model="data.item.info.firebase_id" 
                  type="text" 
                  class="inputfield w-full"
                  :disabled="true"
                  hidden="true"
                />

                <div class="field col-12 md:col-6">
                  <label for="notification">Testo notifica</label>
                  <prime-textarea id="notification" v-model="notifica" rows="3" class="inputfield w-full" :disabled="!data.item.info.updated_at"/>
                  <p v-if="!data.item.info.updated_at">Non è possibile inviare una notifica a questo rappresentante</p>
                </div>

                <prime-button v-if="data.item.info.updated_at"
                  icon="pi pi-send" 
                  class="p-button-rounded p-button-success mr-2"
                  :disabled="notifica == '' ? true : false"
                  @click="sendNotification(notifica)"
                />
              </div>
            </div>
          </div>          
        </div>
      </prime-accordion-tab>

      <prime-accordion-tab header="Provvigioni">
        <div v-if="data.item.id">
          <div class="formgrid grid mb-4">
            <div class="field col-12 md:col-6">
              <label for="anno">Anno</label>
              <Dropdown 
                v-model="selectedAnno" 
                :options="anniDisponibili" 
                optionLabel="name" 
                optionValue="value" 
                placeholder="Seleziona anno" 
                class="w-full"
              />
            </div>
          </div>

          <div v-if="selectedAnno" class="mt-4">
            <RiepilogoProvvigioniRappresentanti 
              :id-rappresentante="data.item.id"
              :rappresentante-name="data.item.info.name"
              :anno-selezionato="selectedAnno"
              :auto-search="true"
            />
          </div>
        </div>
      </prime-accordion-tab>

      <prime-accordion-tab header="Dettaglio Fatturato per Fattura">
      <div v-if="data.item.id">
        <div v-if="detailsInfo && detailsInfo.length">
          <div class="flex justify-content-end mb-3">
            <prime-button
              icon="pi pi-external-link"
              label="Esporta tutto"
              class="p-button-secondary p-button-sm mr-2"
              @click="exportAllDetailsCSV"
            />
          </div>

          <div style="max-height: 500px; overflow-y: auto;">
            <prime-data-table
              :value="detailsInfo"
              responsiveLayout="scroll"
            >
              <prime-column
                field="numero_fattura"
                header="Numero Fattura"
                :sortable="true"
              />
              <prime-column
                field="data_emissione"
                header="Data Emissione"
                :sortable="true"
              >
                <template #body="{ data }">
                  {{ formatCommaSeparatedDates(data.data_emissione) }}
                </template>
              </prime-column>
              <prime-column
                field="mese_fatturazione"
                header="Mese Fatturazione"
                :sortable="true"
              >
                <template #body="{ data }">
                  {{ formatCommaSeparatedDates(data.mese_fatturazione) }}
                </template>
              </prime-column>
              <prime-column
                field="pdp"
                header="PDP"
                :sortable="true"
              />
              <prime-column
                field="tipo_consumo"
                header="Tipo Consumo"
                :sortable="true"
              />
              <prime-column
                field="totale_fattura"
                header="Totale Riga"
                :sortable="true"
              >
                <template #body="{ data }">
                  {{ formatCommaSeparatedNumbers(data.totale_fattura) }}
                </template>
              </prime-column>
              <prime-column
                field="totale_fatturato"
                header="Totale Fatturato"
                :sortable="true"
              >
                <template #body="{ data }">
                  {{ currencyFormatter.format(data.totale_fatturato || 0) }}
                </template>
              </prime-column>
            </prime-data-table>
          </div>

          <div v-if="detailsInfoPagination.total > 0 || (detailsInfo && detailsInfo.length > 0)" class="mt-3">
            <prime-paginator
              :rows="detailsInfoPagination.pageSize"
              :totalRecords="detailsInfoPagination.total || detailsInfo.length"
              :first="(detailsInfoPagination.currentPage - 1) * detailsInfoPagination.pageSize"
              :rowsPerPageOptions="[10, 15, 25, 50]"
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
              currentPageReportTemplate="{first} a {last} di {totalRecords}"
              @page="onDetailsInfoPageChange"
            />
          </div>
        </div>

        <div v-else class="text-center p-4">
          Nessun dato trovato.
        </div>
      </div>
    </prime-accordion-tab>

  </prime-accordion>

  <div v-if="data.item.id" class="mt-3">
    <IncallTicketsBlock
      :entity-id="data.item.id"
      entity-type="rappresentante"
      :contact="ticketContact"
    />
  </div>


  <!-- Dialog new Payment Arriving -->
  <Dialog v-model:visible="newPaymentArrivingDialog" :style="{width: '90%'}" header="Crea pagamento in arrivo" :modal="true" class="p-fluid">
    <div class="grid" style="min-height:150px">
      <div class="col-12 md:col-6">
        <div class="p-field">
          <label>Pagamento</label>
          <Dropdown v-model="selectedTipiMetodoPagamentoCliente" :options="tipiMetodoPagamentoCliente" optionLabel="name" optionValue="id" placeholder="Seleziona"  />
          <small class="p-error" v-if="validationErrors.pay">Campo richiesto</small>
        </div>
      </div>
      <div class="col-12 md:col-6">
        <div class="p-field">
          <label>Importo</label>
          <InputText  v-model.trim="selectedPaymentArriving.saldo"  />
          <small class="p-error" v-if="validationErrors.importo && submitted">Campo richiesto</small>
        </div>
      </div>
    </div>
    <template #footer>
      <Button label="Annulla" icon="pi pi-times" class="p-button-text" @click="newPaymentArrivingDialog = false" />
      <Button label="Salva" icon="pi pi-check" class="p-button-text" @click="createPaymentArriving" />
    </template>
  </Dialog>

</template>

<script>
import RappresentantiService from '@/services/ask-management/rappresentanti-service'
import RepresentativeDocumentsService from '@/services/ask-pratiche/representative-documents-service'
import AccordionDocumentiNomina from '@/components/ask/details/AccordionDocumentiNomina.vue'
import CambioRappresentanteService from '@/services/ask-pratiche/cambio-rappresentante'
import UtilityService from '@/services/ask-management/utility-service'
import {FilterMatchMode} from 'primevue/api';

import Loader from '@/components/Loader.vue'
import ContactImpactDialog from '@/components/ask/details/ContactImpactDialog.vue'
import PrimeButton from 'primevue/button'
import PrimeDropdown from 'primevue/dropdown'
import PrimeTextarea from 'primevue/textarea'
import PrimeInputText from 'primevue/inputtext'
import PrimeAccordion from 'primevue/accordion'
import PrimeAccordionTab from 'primevue/accordiontab'
import PrimeDataTable from 'primevue/datatable'
import PrimeColumn from 'primevue/column'
import PrimePaginator from 'primevue/paginator'
import RiepilogoProvvigioniRappresentanti from '@/components/pratiche/RiepilogoProvvigioniRappresentanti.vue'
import IncallTicketsBlock from '@/components/incall/IncallTicketsBlock.vue'
import SupplyRiepilogoSection from '@/components/ask/details/SupplyRiepilogoSection.vue'

import moment from 'moment'

export default {
  name: 'ViewAskRappresentantiDetail',
  components: {
    AccordionDocumentiNomina,
    PrimeButton,
    PrimeInputText,
    PrimeTextarea,
    PrimeDropdown,
    PrimeAccordion,
    PrimeAccordionTab,
    PrimeDataTable,
    PrimeColumn,
    PrimePaginator,
    RiepilogoProvvigioniRappresentanti,
    IncallTicketsBlock,
    SupplyRiepilogoSection,
    Loader,
    ContactImpactDialog
  },

  data() {
    return {
      moment,
      loader: false,
      changeDocuments: [],
      changeDocumentsLoading: false,
      cambioRappresentanteAvailable: false,
      changeDocumentsError: '',
      changeDocumentOpening: null,
      validationErrors: {},
      submitted: false,
      filters: {
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
      },

      currencyFormatter: new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: 'EUR',
      }),

      route: {
        params: null
      },
      page:{
        notifica: 'notifica'
      },
      notifica: '',
      disabledFirebase_id: true,
      isInEdit: false,
      oldInfo: null,

      year_ciclo: new Date(),
      cicloPayments: [],
      cicloPaymentsAll:[],
      newPaymentArrivingDialog: false,
      selectedPaymentArriving: {},
      tipiMetodoPagamentoCliente: [],
      selectedTipiMetodoPagamentoCliente: {},

      comuni: [],
      toponimi: [],

      editingContactRows: [],
      isContactRowEditing: false,
      duplicateContactIds: [],
      duplicateContactClearTimer: null,
      contactDialog: {
        visible: false,
        header: 'Contratti e caricamenti associati',
        message: '',
        changes: [],
        contact: {},
        contractsHeader: 'Contratti',
        confirmable: false,
        pendingContact: null
      },
      newContact: {
        visible: false,
        comune:0,
        cap:'',
        provincia:'',
        toponimo:'',
        indirizzo:'',
        civico:'',
        email:'',
        pec:'',
        tel:'',
        cell:'',
      },

      data: {
        allegato: {
          allowedType: ['pdf','jpeg','jpg','png'],
          file: [],
          tipo: null,
          note: null
        },

        tipiAllegato: [],
        item: {}
      },

      ticketDialog: {
        visible: false,
        ticket: null
      },

      selectedAnno: null,
      anniDisponibili: [],

      detailsInfo: [],
      detailsInfoPagination: {
        currentPage: 1,
        pageSize: 15,
        total: 0
      }
    }
  },

  created(){
    this.route.params = this.$route.params
    // console.log('Route Params', this.route.params)

    this.loader = true
    this.rappresentantiService = new RappresentantiService(this.$http, this.$eventBus)
    this.representativeDocumentsService = new RepresentativeDocumentsService(this.$http)
    this.loadCambioRappresentanteAvailability()
    this.utilityService = new UtilityService(this.$http, this.$eventBus)
    const promises = [
      this.getDettaglioRappresentante(this.route.params.id),    
      this.getTipiAllegato(),
      this.getTipiMetodoPagamentoCliente(),
      this.getProspettoCicloPagamenti(),
      this.getComuni(),
      this.getToponimi(),
      this.getAnniDisponibili(),
      this.loadDetailsInfoRappresentante()
    ]
    Promise.all(promises).then(()=>{
      this.validateReceivedContacts()
      this.loader = false
    })
  },

  beforeUnmount() {
    this.clearDuplicateContactHighlightTimer()
  },

  methods: {
    async loadCambioRappresentanteAvailability() {
      try {
        this.cambioRappresentanteAvailable = await new CambioRappresentanteService(this.$http).isAvailable()
      } catch (error) {
        this.cambioRappresentanteAvailable = false
      }
      this.representativeDocumentsService.setAvailable(this.cambioRappresentanteAvailable)
    },
    onRepresentativeTabOpen(event) {
      if (Number(event.index) === 2 && this.cambioRappresentanteAvailable) this.loadChangeDocuments()
    },
    async loadChangeDocuments() {
      if (!this.cambioRappresentanteAvailable || !this.data.item.id) return
      this.changeDocumentsLoading = true
      this.changeDocumentsError = ''
      try {
        this.changeDocuments = await this.representativeDocumentsService.getRepresentativeDocuments(this.data.item.id)
      } catch (error) {
        this.changeDocuments = []
        this.changeDocumentsError = 'Impossibile caricare i file da cambio rappresentante.'
      } finally {
        this.changeDocumentsLoading = false
      }
    },
    async openChangeDocument(documento) {
      this.changeDocumentOpening = documento.id
      try {
        await this.representativeDocumentsService.openRepresentativeDocument(this.data.item.id, documento.id)
      } catch (error) {
        this.$eventBus.emit('data-load-error', { message: 'Impossibile visualizzare il documento.' })
      } finally {
        this.changeDocumentOpening = null
      }
    },
    openContactAssociations(contact) {
      this.contactDialog = {
        visible: true,
        header: 'Contratti e caricamenti associati',
        message: '',
        changes: [],
        contact,
        contractsHeader: 'Contratti',
        confirmable: false,
        pendingContact: null
      }
    },
    openTicketDialog(ticket) {
      this.ticketDialog.ticket = ticket;
      this.ticketDialog.visible = true;
    },
    
    async getDettaglioRappresentante(id){
      this.loader = true
      await this.rappresentantiService.getDettaglioRappresentante(id).then((res) => {
        this.data.item = res.item
        if (this.comuni.length && this.toponimi.length) this.validateReceivedContacts()
        document.title = 'info' in this.data.item ? ('name' in this.data.item.info ? document.title+" - "+  this.data.item.info.name : document.title) : document.title
        this.disabledFirebase_id = this.data.item.info.firebase_id == undefined ? false : true;
      })
      .finally(() => {
        this.loader = false
      })
    },
    getComuni(){
      return this.utilityService.getComuniConCap().then((res) => {
        this.comuni = res.items
      })
    },
    getToponimi(){
      return this.utilityService.getToponimi().then((res) => {
        this.toponimi = res.items
      })
    },
    getTipiAllegato(){
      this.utilityService.getTipiAllegato().then((res) => {
        this.data.tipiAllegato = res.items
      })
    },
    getTipiMetodoPagamentoCliente(){
      this.utilityService.getTipiMetodoPagamentoCliente().then((res) => {
        this.tipiMetodoPagamentoCliente = res.items
      })
    },

    getProspettoCicloPagamenti(){
      this.loader = true
      let year = moment(this.year_ciclo).format('YYYY')
      this.rappresentantiService.getProspettoCicloPagamenti(this.route.params.id ,year).then((res) => {
        this.cicloPayments = res.item
        
        for (const el of Object.values(this.cicloPayments)) {
          if ('invoices' in el) {
            el.invoices.forEach(v => {
              this.cicloPaymentsAll.push(v)
            });
          }
        }

      })
      .finally(() => {
        this.loader = false
      })
    },
    async loadDetailsInfoRappresentante(page = null) {
      if (!this.route.params || !this.route.params.id) return
      this.loader = true
      try {
        const currentPage = page !== null ? page : this.detailsInfoPagination.currentPage
        const res = await this.rappresentantiService.getDetailsInfoRappresentante(
          this.route.params.id,
          currentPage,
          this.detailsInfoPagination.pageSize
        )
        this.detailsInfo = res.items || []
        if (res.pagination) {
          const paginationPage = res.pagination.page || {}
          const currentPageNum = paginationPage.current || res.pagination.current_page || res.pagination.currentPage || currentPage
          const pageSizeNum = paginationPage.size || res.pagination.per_page || res.pagination.perPage || res.pagination.pageSize || this.detailsInfoPagination.pageSize
          const lastPageNum = paginationPage.last || 0
          const totalRecords = res.pagination.total || res.pagination.totalRecords || (lastPageNum > 0 && pageSizeNum > 0 ? lastPageNum * pageSizeNum : 0)
          
          this.detailsInfoPagination = {
            currentPage: currentPageNum,
            pageSize: pageSizeNum,
            total: totalRecords
          }
        } else if (this.detailsInfo.length > 0) {
          this.detailsInfoPagination.total = this.detailsInfo.length
        }
      } catch (e) {
        console.error('Errore nel caricamento dei dettagli fatturato rappresentante', e)
      } finally {
        this.loader = false
      }
    },
    onDetailsInfoPageChange(event) {
      this.detailsInfoPagination.currentPage = event.page + 1
      this.detailsInfoPagination.pageSize = event.rows
      this.loadDetailsInfoRappresentante(event.page + 1)
    },
    formatCommaSeparatedDates(value) {
      if (!value) return ''
      const dates = value.split(', ').filter(Boolean)
      return dates.map(date => this.moment(date).format('DD/MM/YYYY')).join(', ')
    },
    formatCommaSeparatedNumbers(value) {
      if (!value) return ''
      const numbers = value.split(', ').filter(Boolean)
      return numbers.map(num => {
        const numValue = parseFloat(num) || 0
        return this.currencyFormatter.format(numValue)
      }).join(', ')
    },
    getFatturaDettagli(fattura) {
      if (!fattura) return []
      
      const dataEmissione = (fattura.data_emissione || '').split(', ').filter(Boolean)
      const meseFatturazione = (fattura.mese_fatturazione || '').split(', ').filter(Boolean)
      const pdp = (fattura.pdp || '').split(', ').filter(Boolean)
      const tipoConsumo = (fattura.tipo_consumo || '').split(', ').filter(Boolean)
      const totaleFattura = (fattura.totale_fattura || '').split(', ').filter(Boolean)
      
      const maxLength = Math.max(
        dataEmissione.length,
        meseFatturazione.length,
        pdp.length,
        tipoConsumo.length,
        totaleFattura.length
      )
      
      const dettagli = []
      for (let i = 0; i < maxLength; i++) {
        dettagli.push({
          data_emissione: dataEmissione[i] || '',
          mese_fatturazione: meseFatturazione[i] || '',
          pdp: pdp[i] || '',
          tipo_consumo: tipoConsumo[i] || '',
          totale_fattura: totaleFattura[i] || ''
        })
      }
      
      return dettagli
    },
    exportDetailsCSV(index) {
      if (!this.detailsInfo || !this.detailsInfo.length) return
      const fattura = this.detailsInfo[index]
      if (!fattura) return

      const headers = [
        'Data Emissione',
        'Mese Fatturazione',
        'PDP',
        'Tipo Consumo',
        'Totale Riga'
      ]

      const formatDate = (val) => {
        return val ? this.moment(val).format('DD/MM/YYYY') : ''
      }

      const escape = (val) => {
        const s = val == null ? '' : String(val)
        return `"${s.replace(/"/g, '""')}"`
      }

      let csv = headers.join(';') + '\n'

      const dettagli = this.getFatturaDettagli(fattura)
      const fatturaTotale = Number(fattura.totale_fatturato) || 0

      dettagli.forEach((det) => {
        const row = [
          escape(formatDate(det.data_emissione)),
          escape(formatDate(det.mese_fatturazione)),
          escape(det.pdp),
          escape(det.tipo_consumo),
          escape(det.totale_fattura)
        ].join(';')
        csv += row + '\n'
      })

      const separatorRow = [
        '',
        '',
        '',
        '',
        escape('---------------------')
      ].join(';')
      csv += separatorRow + '\n'

      const totalRow = [
        escape('TOTALE FATTURA'),
        '',
        '',
        '',
        escape(`${fatturaTotale.toFixed(2)}`)
      ].join(';')
      csv += totalRow + '\n'

      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = `dettaglio fatturato ${fattura.numero_fattura}.csv`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    },
    async exportAllDetailsCSV() {
      if (!this.route.params || !this.route.params.id) return

      this.loader = true
      try {
        const res = await this.rappresentantiService.getDetailsInfoRappresentante(
          this.route.params.id,
          1,
          100000 
        )
        
        const allDetailsInfo = res.items || []
        if (!allDetailsInfo || !allDetailsInfo.length) {
          this.loader = false
          return
        }

        const headers = [
          'Numero Fattura',
          'Data Emissione',
          'Mese Fatturazione',
          'PDP',
          'Tipo Consumo',
          'Totale Riga'
        ]

        const formatDate = (val) => {
          return val ? this.moment(val).format('DD/MM/YYYY') : ''
        }

        const escape = (val) => {
          const s = val == null ? '' : String(val)
          return `"${s.replace(/"/g, '""')}"`
        }

        let csv = headers.join(';') + '\n'

        allDetailsInfo.forEach(fattura => {
        const numero = fattura.numero_fattura
        const dettagli = this.getFatturaDettagli(fattura)
        if (!dettagli.length) return

        dettagli.forEach((det, idx) => {
          const numeroCell = idx === 0 ? numero : '' 
          const row = [
            escape(numeroCell),
            escape(formatDate(det.data_emissione)),
            escape(formatDate(det.mese_fatturazione)),
            escape(det.pdp),
            escape(det.tipo_consumo),
            escape(det.totale_fattura)
          ].join(';')
          csv += row + '\n'
        })
        })

        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        const namePart = this.data.item?.info?.name || 'rappresentante'
        link.download = `dettaglio fatturato ${namePart}.csv`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
      } catch (e) {
        console.error('Errore nell\'esportazione CSV:', e)
      } finally {
        this.loader = false
      }
    },
    openPaymentArrivingDialog(item) {
      this.selectedPaymentArriving = item
      this.newPaymentArrivingDialog = true
    },
    createPaymentArriving () {
      if (this.validateToNewPaymentArriving()) {
        console.log(this.selectedPaymentArriving);
      }
    },
    addNewContact() {
      this.submitted = true
      const contact = this.newContactForSave()
      const isValid = this.validateNewContact(contact)
      const contactValidationErrors = this.getContactValidationErrors(contact, { requirePec: true })
      const duplicateContacts = this.findDuplicateContacts(contact)

      if (!isValid || duplicateContacts.length) {
        this.showContactIssues(contactValidationErrors, duplicateContacts, 'creare')
        return
      }

      this.duplicateContactIds = []
      this.$confirm.require({
        group: 'contact-edit',
        message: 'Confermi la creazione del nuovo contatto?',
        contact: null,
        contactSummary: this.getNewContactSummary(contact),
        changes: [],
        validationErrors: [],
        header: 'Conferma nuovo contatto',
        acceptLabel: 'Conferma',
        rejectLabel: 'Annulla',
        accept: () => this.createNewContact(contact)
      })
    },
    createNewContact(contact) {
      this.loader = true
      this.rappresentantiService.addNewContact(contact, this.data.item.id)
        .then(() => {
          this.resetNewContactForm()
          this.getDettaglioRappresentante(this.data.item.id)
        })
        .finally(() => {
          this.loader = false
        })
    },
    resetNewContactForm() {
      Object.assign(this.newContact, {
        visible: false,
        comune: 0,
        cap: '',
        provincia: '',
        toponimo: '',
        indirizzo: '',
        civico: '',
        email: '',
        pec: '',
        tel: '',
        cell: ''
      })

      Object.keys(this.validationErrors).forEach(field => {
        if (field.startsWith('newContact_')) delete this.validationErrors[field]
      })
      this.submitted = false
    },
    toggleNewContactForm() {
      if (this.isContactRowEditing) this.cancelActiveContactRowEdit()

      if (this.newContact.visible) {
        this.resetNewContactForm()
        return
      }

      this.resetNewContactForm()
      this.newContact.visible = true
    },
    newContactForSave() {
      const selectedComune = this.comuni.find(comune => String(comune.id) === String(this.newContact.comune))

      return {
        ...this.newContact,
        comune: this.newContact.comune,
        cod_comune: this.newContact.comune,
        nome_comune: selectedComune?.name || '',
        provincia: selectedComune?.provincia || ''
      }
    },
    normalizeContactText(value) {
      return String(value ?? '').normalize('NFKC').trim().replace(/\s+/g, ' ').toLocaleUpperCase('it-IT')
    },
    normalizeContactEmail(value) {
      return String(value ?? '').normalize('NFKC').trim().replace(/\s+/g, ' ').toLocaleLowerCase('it-IT')
    },
    normalizeContactPhone(value) {
      return String(value ?? '').replace(/[_\s-]/g, '')
    },
    hasContactValue(value) {
      return value !== null && value !== undefined && String(value).trim() !== ''
    },
    isValidContactEmail(value) {
      const email = String(value || '').trim()
      const parts = email.split('@')
      if (parts.length !== 2) return false

      const [localPart, domain] = parts
      if (!localPart || !domain || localPart.startsWith('.') || localPart.endsWith('.') || localPart.includes('..')) return false
      if (!/^[A-Z0-9.!#$%&'*+/=?^_`{|}~-]+$/i.test(localPart)) return false

      const domainParts = domain.split('.')
      if (domainParts.length < 2 || domainParts.some(part => !part)) return false
      if (!domainParts.slice(0, -1).every(part => /^[A-Z0-9](?:[A-Z0-9-]{0,61}[A-Z0-9])?$/i.test(part))) return false

      const tld = domainParts[domainParts.length - 1]
      return /^[A-Z]{2,63}$/i.test(tld)
    },
    isValidContactPec(value) {
      const pec = String(value || '').trim()
      if (!this.isValidContactEmail(pec)) return false

      const tld = pec.split('.').pop().toLowerCase()
      return !['example', 'invalid', 'localhost', 'local', 'test'].includes(tld)
    },
    isValidContactMobile(value) {
      const rawMobile = String(value || '').trim()
      if (/[^\d\s_-]/.test(rawMobile)) return false
      const mobile = rawMobile.replace(/\D/g, '')
      return /^3\d{8,9}$/.test(mobile)
        && !/(\d)\1{4}/.test(mobile)
        && !/^(\d)\1+$/.test(mobile)
        && !/^3(\d)\1+$/.test(mobile)
        && !['3123456789', '3234567890', '3987654321', '3098765432'].includes(mobile)
    },
    isContactPecBypassActive(contact) {
      const bypass = contact.bypass_pec
      return bypass && typeof bypass === 'object'
        ? bypass.value === true || Number(bypass.value) === 1
        : Number(bypass) === 1
    },
    onContactPecChange(contact, value) {
      contact.pec = value
      if (!this.hasContactValue(value)) return

      contact.bypass_pec = 0
      contact.motivazione_bypass_pec = null
    },
    onContactPecBypassChange(contact, value) {
      contact.bypass_pec = value
      if (this.isContactPecBypassActive(contact)) return
      contact.motivazione_bypass_pec = null
    },
    findContactComune(contact) {
      const comuneId = contact.cod_comune ?? contact.comune
      const byId = this.comuni.find(comune => String(comune.id) === String(comuneId))
      if (byId) return byId

      const comuneName = this.normalizeContactText(contact.nome_comune || contact.comune)
      const provincia = this.normalizeContactText(contact.provincia)
      return this.comuni.find(comune => this.normalizeContactText(comune.name) === comuneName
        && this.normalizeContactText(comune.provincia) === provincia) || null
    },
    isContactCapValid(cap, comune) {
      const value = this.normalizeContactText(cap)
      const comuneCap = this.normalizeContactText(comune?.cap)
      if (!/^\d{5}$/.test(value)) return false
      if (/^\d{3}XX$/.test(comuneCap)) return value.startsWith(comuneCap.slice(0, 3))
      return /^\d{5}$/.test(comuneCap) && value === comuneCap
    },
    contactCapSettings(contact) {
      const comune = this.findContactComune(contact)
      const cap = this.normalizeContactText(comune?.cap)
      const isWildcard = /^\d{3}XX$/.test(cap)
      const isFixed = /^\d{5}$/.test(cap)

      return {
        comune,
        cap,
        isWildcard,
        isFixed,
        prefix: isWildcard ? cap.slice(0, 3) : '',
        initialValue: isWildcard ? cap.slice(0, 3) : (isFixed ? cap : '')
      }
    },
    prepareContactCapForEdit(contact) {
      const settings = this.contactCapSettings(contact)
      if (!settings.comune || this.isContactCapValid(contact.cap, settings.comune)) return
      contact.cap = settings.initialValue
    },
    contactCapSuffix(contact) {
      const prefix = this.contactCapSettings(contact).prefix
      const cap = String(contact.cap || '')
      return cap.startsWith(prefix) ? cap.slice(prefix.length, prefix.length + 2) : ''
    },
    updateMultiCapSuffix(contact, value) {
      const prefix = this.contactCapSettings(contact).prefix
      const suffix = String(value || '').replace(/\D/g, '').slice(0, 2)
      contact.cap = `${prefix}${suffix}`
    },
    isContactRowSaveDisabled(contact) {
      return Object.keys(this.getContactValidationErrors(contact)).length > 0
    },
    isNewContactSaveDisabled() {
      return Object.keys(this.getContactValidationErrors(this.newContactForSave(), { requirePec: true })).length > 0
    },
    contactRowSaveDisabledTooltip(contact) {
      return Object.values(this.getContactValidationErrors(contact)).join(' · ')
    },
    getContactValidationErrors(contact, { requirePec = false } = {}) {
      const errors = {}
      const comune = this.findContactComune(contact)
      const toponimo = this.normalizeContactText(contact.toponimo)
      const validToponimo = toponimo && this.toponimi.some(item => this.normalizeContactText(item.name) === toponimo)

      if (!validToponimo) errors.toponimo = 'Il toponimo è obbligatorio e deve essere uno dei valori previsti.'
      if (!this.hasContactValue(contact.indirizzo)) errors.indirizzo = 'L’indirizzo è obbligatorio.'
      if (!this.hasContactValue(contact.civico)) errors.civico = 'Il civico è obbligatorio.'
      if (!comune) errors.comune = 'Il comune è obbligatorio e deve essere valido.'
      if (!this.isContactCapValid(contact.cap, comune)) errors.cap = 'Il CAP non è valido per il comune selezionato.'
      if (!comune || this.normalizeContactText(contact.provincia) !== this.normalizeContactText(comune.provincia)) {
        errors.provincia = 'La provincia deve coincidere con quella del comune.'
      }
      if (!this.isValidContactEmail(contact.email)) errors.email = 'L’email è obbligatoria e deve avere un formato valido.'

      const pecPresent = this.hasContactValue(contact.pec)
      const bypassActive = !requirePec && this.isContactPecBypassActive(contact)
      if ((!bypassActive && !pecPresent) || (pecPresent && !this.isValidContactPec(contact.pec))) {
        errors.pec = bypassActive
          ? 'La PEC, se presente, deve avere un formato valido.'
          : 'La PEC è obbligatoria e deve avere un formato valido.'
      }
      if (bypassActive && !this.hasContactValue(contact.motivazione_bypass_pec)) {
        errors.motivazione_bypass_pec = 'La motivazione del bypass PEC è obbligatoria.'
      }

      if (!this.isValidContactMobile(contact.cellulare || contact.cell)) {
        errors.cell = 'Il cellulare deve iniziare con 3, contenere 9 o 10 cifre e rispettare le regole sulle sequenze.'
      }

      return errors
    },
    applyContactValidation(contact) {
      const validationErrors = this.getContactValidationErrors(contact)
      return {
        ...contact,
        invalid_fields: Object.keys(validationErrors),
        validation_errors: validationErrors
      }
    },
    validateReceivedContacts() {
      if (!Array.isArray(this.data.item.contatti)) return
      const validatedContacts = this.data.item.contatti.map(contact => this.applyContactValidation(contact))
      const processedContacts = []

      this.data.item.contatti = validatedContacts.map(contact => {
        const parent = processedContacts.find(existingContact => this.areContactsDuplicate(existingContact, contact))
        const contactWithDuplicateInfo = {
          ...contact,
          duplicate_of: parent?.id ?? null
        }
        processedContacts.push(contactWithDuplicateInfo)
        return contactWithDuplicateInfo
      })
    },
    hasContactValidationErrors(contact) {
      return Boolean(contact.invalid_fields?.length)
    },
    contactFieldError(contact, field) {
      return contact.validation_errors?.[field] || ''
    },
    contactValidationErrorList(errors) {
      return Object.entries(errors).map(([field, message]) => ({ field, message }))
    },
    contactPecComparableValue(contact) {
      const pec = this.normalizeContactEmail(contact.pec)
      return pec ? `pec:${pec}` : `bypass:${this.isContactPecBypassActive(contact) ? '1' : '0'}`
    },
    contactComuneComparableValue(contact) {
      const comune = this.findContactComune(contact)
      return comune
        ? `id:${this.normalizeContactText(comune.id)}`
        : `name:${this.normalizeContactText(contact.nome_comune || contact.comune)}`
    },
    contactComparableValues(contact) {
      return [
        this.normalizeContactText(contact.toponimo),
        this.normalizeContactText(contact.indirizzo),
        this.normalizeContactText(contact.civico),
        this.normalizeContactText(contact.cap),
        this.contactComuneComparableValue(contact),
        this.normalizeContactText(contact.provincia),
        this.normalizeContactPhone(contact.cellulare || contact.cell),
        this.normalizeContactEmail(contact.email),
        this.contactPecComparableValue(contact),
        this.normalizeContactPhone(contact.telefono || contact.tel),
        this.normalizeContactPhone(contact.fax)
      ]
    },
    areContactsDuplicate(firstContact, secondContact) {
      const firstValues = this.contactComparableValues(firstContact)
      const secondValues = this.contactComparableValues(secondContact)

      return firstValues.every((value, index) => (
        value.localeCompare(secondValues[index], 'it-IT', { sensitivity: 'base' }) === 0
      ))
    },
    findDuplicateContacts(contact, excludedId = null) {
      const contactValues = this.contactComparableValues(contact)

      return (this.data.item.contatti || []).filter(existingContact => {
        if (excludedId != null && String(existingContact.id) === String(excludedId)) return false
        return this.contactComparableValues(existingContact).every((value, index) => (
          value.localeCompare(contactValues[index], 'it-IT', { sensitivity: 'base' }) === 0
        ))
      })
    },
    showContactIssues(validationErrors, duplicateContacts, action) {
      const hasValidationErrors = Object.keys(validationErrors).length > 0
      this.clearDuplicateContactHighlightTimer()
      this.duplicateContactIds = duplicateContacts.map(contact => contact.id)
      const hasDuplicates = duplicateContacts.length > 0

      let header = 'Contatto non conforme'
      let message = `Non è possibile ${action} il contatto perché alcuni dati non sono conformi.`
      if (hasDuplicates && hasValidationErrors) {
        header = 'Contatto non conforme e duplicato'
        message = `Non è possibile ${action} il contatto: correggi gli errori indicati e utilizza il contatto già esistente.`
      } else if (hasDuplicates) {
        header = 'Contatto duplicato'
        message = `Non è possibile ${action} il contatto: coincide con ${duplicateContacts.length === 1 ? 'un contatto già presente' : `${duplicateContacts.length} contatti già presenti`} per questo rappresentante.`
      }

      this.$confirm.require({
        group: 'contact-edit',
        message,
        contact: duplicateContacts[0] || null,
        duplicateContacts,
        changes: [],
        validationErrors: this.contactValidationErrorList(validationErrors),
        header,
        acceptLabel: 'Ho capito',
        rejectClass: 'hidden',
        accept: () => this.scheduleDuplicateContactHighlightRemoval(),
        onHide: () => this.scheduleDuplicateContactHighlightRemoval()
      })
    },
    clearDuplicateContactHighlightTimer() {
      if (this.duplicateContactClearTimer) {
        clearTimeout(this.duplicateContactClearTimer)
        this.duplicateContactClearTimer = null
      }
    },
    scheduleDuplicateContactHighlightRemoval() {
      this.clearDuplicateContactHighlightTimer()
      if (!this.duplicateContactIds.length) return

      this.duplicateContactClearTimer = setTimeout(() => {
        this.duplicateContactIds = []
        this.duplicateContactClearTimer = null
      }, 5000)
    },
    isDuplicateContact(contact) {
      return this.duplicateContactIds.some(id => String(contact.id) === String(id))
    },
    contactRowClass(contact) {
      return {
        'duplicate-contact-row': this.isDuplicateContact(contact),
        'invalid-contact-row': this.hasContactValidationErrors(contact)
      }
    },
    contactAddress(contact) {
      const comune = contact.nome_comune || contact.comune || ''
      return [
        [contact.toponimo, contact.indirizzo, contact.civico].filter(Boolean).join(' '),
        [contact.cap, comune, contact.provincia].filter(Boolean).join(' ')
      ].filter(Boolean).join(', ') || '(indirizzo non disponibile)'
    },
    onContactRowEditInit(event){
      this.resetNewContactForm()
      this.clearDuplicateContactHighlightTimer()
      this.duplicateContactIds = []
      this.isContactRowEditing = true
      this.data.item.contatto_index = event.index
      this.data.item.contatto_old = {...event.data}
      if (this.hasContactValue(event.newData.pec)) {
        event.newData.bypass_pec = 0
        event.newData.motivazione_bypass_pec = null
      }
      this.prepareContactCapForEdit(event.newData)
    },    
    onContactRowEditCancel(event){
      this.cancelActiveContactRowEdit(event.index)
    },
    cancelActiveContactRowEdit(index = this.data.item.contatto_index) {
      if (index != null) this.restoreContactRow(index, this.data.item.contatto_old)
      this.editingContactRows = []
      this.isContactRowEditing = false
      this.data.item.contatto_index = null
      this.data.item.contatto_old = null
    },
    restoreContactRow(index, contact) {
      if (!contact || !Array.isArray(this.data.item.contatti)) return
      this.data.item.contatti.splice(index, 1, {...contact})
    },
    onChangeComuneContact(event, contact){
      let newcomune = this.comuni.filter(el => el.id == event.value)

      if (newcomune.length > 0) {
        contact.cod_comune = newcomune[0].id
        contact.comune = newcomune[0].name
        contact.provincia = newcomune[0].provincia
        contact.cap = this.contactCapSettings(contact).initialValue
      }
    },
    onChangeNewContactComune(event) {
      const comune = this.comuni.find(item => String(item.id) === String(event.value))
      this.newContact.provincia = comune?.provincia || ''
      this.newContact.cap = comune ? this.contactCapSettings(this.newContact).initialValue : ''
    },
    formatContactChangeValue(value, field = null) {
      if (field === 'bypass_pec') {
        return this.isContactPecBypassActive({ bypass_pec: value }) ? 'Attivo' : 'Non attivo'
      }
      return value === null || value === undefined || value === '' ? '(vuoto)' : String(value)
    },
    getNewContactSummary(contact) {
      return [
        { field: 'toponimo', label: 'Toponimo', value: contact.toponimo },
        { field: 'indirizzo', label: 'Indirizzo', value: contact.indirizzo },
        { field: 'civico', label: 'Civico', value: contact.civico },
        { field: 'comune', label: 'Comune', value: contact.nome_comune },
        { field: 'cap', label: 'CAP', value: contact.cap },
        { field: 'provincia', label: 'Provincia', value: contact.provincia },
        { field: 'cell', label: 'Cellulare', value: contact.cell },
        { field: 'email', label: 'Email', value: contact.email },
        { field: 'pec', label: 'PEC', value: contact.pec },
        { field: 'tel', label: 'Telefono', value: contact.tel }
      ].map(item => ({
        ...item,
        value: item.value === null || item.value === undefined || item.value === '' ? 'Non indicato' : String(item.value)
      }))
    },
    getContactChanges(oldContact, newContact) {
      const editableFields = [
        { field: 'toponimo', label: 'Toponimo' },
        { field: 'indirizzo', label: 'Indirizzo' },
        { field: 'civico', label: 'Civico' },
        { field: 'cap', label: 'CAP' },
        { field: 'cod_comune', valueField: 'comune', label: 'Comune' },
        { field: 'provincia', label: 'Provincia' },
        { field: 'email', label: 'Email' },
        { field: 'pec', label: 'PEC' },
        { field: 'bypass_pec', label: 'Bypass PEC' },
        { field: 'motivazione_bypass_pec', label: 'Motivazione bypass PEC' },
        { field: 'fax', label: 'Fax' },
        { field: 'tel', label: 'Telefono' },
        { field: 'cell', label: 'Cellulare' }
      ]

      return editableFields
        .filter(item => oldContact[item.field] !== newContact[item.field])
        .map(item => {
          const valueField = item.valueField || item.field

          return {
            field: item.field,
            label: item.label,
            oldValue: this.formatContactChangeValue(oldContact[valueField], item.field),
            newValue: this.formatContactChangeValue(newContact[valueField], item.field)
          }
        })
    },
    onContactRowEditSave(event){
      this.isContactRowEditing = false
      const oldContact = {...(this.data.item.contatto_old || event.data)}
      const newContact = {...event.newData}
      const changes = this.getContactChanges(oldContact, newContact)
      const contactValidationErrors = this.getContactValidationErrors(newContact)
      const duplicateContacts = this.findDuplicateContacts(newContact, oldContact.id)

      // PrimeVue chiude l'editor prima della conferma: manteniamo a video i dati
      // persistiti e inviamo la copia modificata solo dopo l'accettazione.
      this.restoreContactRow(event.index, oldContact)

      if (Object.keys(contactValidationErrors).length || duplicateContacts.length) {
        this.showContactIssues(contactValidationErrors, duplicateContacts, 'modificare')
        return
      }

      this.duplicateContactIds = []

      const hasAssociations = (Array.isArray(oldContact.contratti) && oldContact.contratti.length)
        || (Array.isArray(oldContact.caricamenti) && oldContact.caricamenti.length)

      this.contactDialog = {
        visible: true,
        header: 'Conferma modifica contatto',
        message: hasAssociations
          ? 'Confermi la modifica del contatto? Attenzione: la modifica sarà applicata anche ai contratti e/o caricamenti associati indicati di seguito.'
          : 'Confermi la modifica del contatto?',
        contact: oldContact,
        changes,
        contractsHeader: 'Contratti interessati',
        confirmable: true,
        pendingContact: newContact
      }
    },
    confirmContactImpact() {
      if (this.contactDialog.pendingContact) {
        this.updateContact(this.contactDialog.pendingContact)
      }
      this.contactDialog.pendingContact = null
    },
    updateContact(contact){
      this.loader = true
      this.rappresentantiService.updateContact(contact, this.data.item.id)
      .then((saved) => {
        if (saved) {
          return this.getDettaglioRappresentante(this.data.item.id)
        }
      })
      .finally(() => {
        this.loader = false
      })
    },
    downloadScansioni(item){
      this.loader = true
      this.utilityService.downloadScansioni(item)
      .finally(() => {
        this.loader = false
      })
    },

    openScansioni(item){
      this.loader = true
      this.utilityService.openScansioni(item)
      .finally(() => {
        this.loader = false
      })
    },

    downloadDocumenti(item){
      this.loader = true
      this.utilityService.downloadDocumenti(item)
      .finally(() => {
        this.loader = false
      })
    },

    openDocumenti(item){
      this.loader = true
      this.utilityService.openDocumenti(item)
      .finally(() => {
        this.loader = false
      })
    },
    handleFileUpload(event) {
      this.data.allegato.file = []
      this.data.allegato.file = event.target.files;
      // console.log(this.data.allegato.file)
    },
    uploadDocumenti() {
      this.submitted = true
      if (this.validateToUpload()) {
        this.loader = true
        let fd = new FormData();
        for (let i = 0 ; i < this.data.allegato.file.length ; i++) {
            fd.append('files[]', this.data.allegato.file[i]); 
        }
        fd.append('id', this.data.item.id);
        fd.append('obj', 'rappresentante');
        fd.append('tipo', this.data.allegato.tipo);
        fd.append('note', this.data.allegato.note);

        this.utilityService.uploadDocumenti(fd)
        .then(() =>{
          this.getDettaglioRappresentante(this.data.item.id)
        })
        .finally(() => {
          this.loader = false
        })
      }
    },
    openDetail(event) {
      let {data} = event
      if ('numero' in data) {
        window.open(`/ask/clienti/fatture/${data.numero}/dettagli`, '_blank')
      } 
    },
    formatCurrency(value) {
      return value.toLocaleString('it-IT', {style: 'currency', currency: 'EUR'});
    },
    validateToUpload() {

      this.validationErrors = {}

      if (!this.data.allegato.tipo) {
          this.validationErrors['tipo'] = true;
      } else {
        delete  this.validationErrors['tipo'];
      }

      if (this.data.allegato.file.length == 0) {
          this.validationErrors['files'] = true;
      } else {
        delete  this.validationErrors['files'];
      }

      if (this.data.allegato.file.length > 0) {
        let valid = [...this.data.allegato.file].every(file => this.data.allegato.allowedType.includes(file.type.replace(/(.*)\//g, '')), false);
        if (valid) 
          delete  this.validationErrors['type'];
        else
           this.validationErrors['type'] = true;
      }

      return !Object.keys(this.validationErrors).length;
 
    },
    validateToNewPaymentArriving() {

      this.validationErrors = {}

      if ('id' in this.selectedTipiMetodoPagamentoCliente) {
        delete  this.validationErrors['pay'];
      } else {
        this.validationErrors['pay'] = true;
      }

      if (this.selectedPaymentArriving.saldo) {
        delete  this.validationErrors['importo'];
      } else {
        this.validationErrors['importo'] = true;
      }

      
      return !Object.keys(this.validationErrors).length;
 
    },

    validateNewContact(contact) {
      this.validationErrors = {}
      const contactErrors = this.getContactValidationErrors(contact, { requirePec: true })
      Object.entries(contactErrors).forEach(([field, message]) => {
        this.validationErrors[`newContact_${field}`] = message
      })

      return !Object.keys(this.validationErrors).length;
    },

    onEditInfo(){
      this.oldInfo = JSON.stringify(this.data.item.info)

      this.isInEdit = !this.isInEdit
    },

    sendNotification(notifica){
      
      this.loader = true
      let fd = new FormData();
      let type_severity = 'error'
      let type_summary = 'Attenzione'
      let type_detail = 'Campo notifica vuoto'
      if (!notifica) {
        this.loader = false
        this.$toast.add({severity:type_severity, summary: type_summary, detail:type_detail, group: this.page.notifica, life: 5000});
      }else{
        fd.append('message', notifica);
        fd.append('userid', this.data.item.info.firebase_id);

        this.utilityService.sendPushNotice(fd)
        .then((res) =>{
          type_detail = 'Errore nell\'invio della notifica'
          if (res.item.success) {
            type_severity = 'success'
            type_summary = 'Successo'
            type_detail = 'Notifica inviata'
          }
          this.$toast.add({severity:type_severity, summary: type_summary, detail:type_detail, group: this.page.notifica, life: 5000});
        })
        .finally(() => {
          this.notifica = ''
          this.loader = false
        })
      }
    },

    onAbortInfoEdit(){
      this.data.item.info = JSON.parse(this.oldInfo)

      this.oldInfo = null
      this.isInEdit = !this.isInEdit
    },

    async onUpdateInfo(){
      const allowed = [
        'name', 'codfis', 'email', 'pec', 'note'
      ]
      
      const info = Object.keys(this.data.item.info)
      .filter(key => allowed.includes(key))
      .reduce((obj, key) => {
        return {
          ...obj,
          [key]: this.data.item.info[key]
        };
      }, {})
      
      if( this.oldInfo != JSON.stringify(this.data.item.info) ) {
        const res = await this.rappresentantiService.updateInfo(this.data.item.id, info)
        if (!res.success) {
          this.$toast.add({ severity: 'error', summary: 'Rappresentante non aggiornato', detail: res.error || 'Verifica i dati inseriti.', life: 5000 })
          return
        }
        delete res.item.id
        this.data.item.info = res.item
      }

      this.oldInfo = null
      this.isInEdit = !this.isInEdit
    },
    exportCSV(month){
      this.$refs[`dt_${month}`].exportCSV();
    },

    async getAnniDisponibili() {
      const currentYear = new Date().getFullYear();
      this.anniDisponibili = [];
      for (let year = currentYear; year >= currentYear - 10; year--) {
        this.anniDisponibili.push({
          name: year.toString(),
          value: year
        });
      }
    }
  },

  computed: {
    identityDocuments() { return this.changeDocuments.filter(documento => documento.ref === 'di') },
    ticketContact() {
      const info = this.data.item.info || {}
      return {
        id: this.data.item.id,
        rappresentante_id: this.data.item.id,
        entity_type: 'rappresentante',
        nome: info.name,
        email: info.email,
        telefono: info.telefono,
      }
    }
  }

}
</script>

<style scoped>
.payment-arriving {
  font-size: 11px;
}
.export-all {
  color: #2196F3;
  cursor: pointer;
}
.association-section + .association-section {
  margin-top: 1.5rem;
  padding-top: 1.25rem;
  border-top: 1px solid var(--surface-border);
}
.association-section h5 {
  margin: 0 0 0.75rem;
}
.association-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.contract-chip-link {
  display: inline-flex;
  text-decoration: none;
}
.contract-chip-legend {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin-bottom: 0.75rem;
  color: var(--text-color-secondary);
}
.contract-chip-link:hover {
  filter: brightness(0.95);
}
.contract-chip-link :deep(.contract-chip-active) {
  background: #d8f3df;
  color: #166534;
}
.contract-chip-link :deep(.contract-chip-warning) {
  background: #fff1bd;
  color: #854d0e;
}
.contract-chip-link :deep(.contract-chip-inactive) {
  background: #fbe0e0;
  color: #991b1b;
}
.contract-chip-link :deep(.contract-chip-neutral) {
  background: #e9edf2;
  color: #475569;
}
.contact-edit-confirmation {
  width: 100%;
}

.duplicate-contact-section {
  margin-top: 1.25rem;
  padding: 1rem;
  border: 1px solid #f59e0b;
  border-radius: 6px;
  background: #fffbeb;
  color: #78350f;
  line-height: 1.5;
}
.duplicate-contact-section + .duplicate-contact-section {
  margin-top: 0.75rem;
}
.duplicate-contacts-list {
  max-height: 20rem;
  overflow-y: auto;
}
.contact-validation-section {
  margin-top: 1.25rem;
  padding: 1rem;
  border: 1px solid #ef4444;
  border-radius: 6px;
  background: #fef2f2;
  color: #991b1b;
}
.contact-validation-section ul {
  margin: 0.75rem 0 0;
  padding-left: 1.25rem;
}
.contact-validation-icon {
  color: #dc2626;
  cursor: help;
}
.duplicate-contact-title {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  margin-bottom: 0.5rem;
}
.duplicate-contact-dialog-hand {
  display: inline-block;
  font-size: 1.6rem;
  animation: duplicate-contact-hand 0.9s ease-in-out infinite;
}
.contact-toponimo-cell,
.contact-field-cell {
  display: flex;
  align-items: center;
  min-height: 2rem;
}
.contact-id-cell {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.35rem;
}
.contact-id-main {
  display: flex;
  align-items: center;
}
.contact-duplicate-label {
  display: inline-flex;
  padding: 0.2rem 0.5rem;
  border-radius: 999px;
  background: #fef3c7;
  color: #92400e;
  font-size: 0.75rem;
  font-weight: 600;
  white-space: nowrap;
}
.multicap-editor {
  display: flex;
  align-items: stretch;
  min-width: 8rem;
}
.multicap-prefix {
  display: inline-flex;
  align-items: center;
  padding: 0 0.65rem;
  border: 1px solid var(--surface-border);
  border-right: 0;
  border-radius: 6px 0 0 6px;
  background: var(--surface-100);
  color: var(--text-color-secondary);
  font-weight: 600;
}
.multicap-suffix {
  width: 4rem;
  border-radius: 0 6px 6px 0;
}
.duplicate-contact-badge {
  display: inline-block;
  margin-right: 0.5rem;
  font-size: 1.5rem;
  line-height: 1;
  pointer-events: none;
  animation: duplicate-contact-hand 0.9s ease-in-out infinite;
}
:deep(.duplicate-contact-row) {
  position: relative;
  z-index: 1;
  animation: duplicate-contact-pulse 1.3s ease-in-out infinite;
}
:deep(.duplicate-contact-row > td) {
  background: #fffbeb !important;
  border-top-color: #f59e0b !important;
  border-bottom-color: #f59e0b !important;
}
:deep(.p-datatable-tbody > tr.invalid-contact-row > td),
:deep(.p-datatable-tbody > tr.invalid-contact-row:hover > td) {
  background: #fee2e2 !important;
  border-top-color: #ef4444 !important;
  border-bottom-color: #ef4444 !important;
}
:deep(.p-datatable-tbody > tr.invalid-contact-row > td:first-child) {
  border-left: 4px solid #dc2626 !important;
}
@keyframes duplicate-contact-hand {
  0%, 100% { transform: translateX(0); }
  50% { transform: translateX(0.4rem); }
}
@keyframes duplicate-contact-pulse {
  0%, 100% { filter: brightness(1); }
  50% { filter: brightness(0.94); }
}
@media (prefers-reduced-motion: reduce) {
  .duplicate-contact-dialog-hand,
  .duplicate-contact-badge,
  :deep(.duplicate-contact-row) {
    animation: none;
  }
}
.contact-associations-accordion {
  margin-top: 1.25rem;
}
.contact-associations-accordion .association-chips {
  max-height: 12rem;
  overflow-y: auto;
  align-content: flex-start;
}
.contact-summary-section,
.contact-changes-section {
  margin-top: 1.25rem;
  padding: 1rem;
  background: var(--surface-50);
  border: 1px solid var(--surface-border);
  border-radius: 6px;
}
.contact-summary-section h5,
.contact-changes-section h5 {
  margin: 0 0 0.75rem;
}
.contact-summary-row {
  display: grid;
  grid-template-columns: minmax(7rem, 0.7fr) auto minmax(0, 1.3fr);
  gap: 0.75rem;
  align-items: baseline;
}
.contact-summary-row + .contact-summary-row {
  margin-top: 0.55rem;
  padding-top: 0.55rem;
  border-top: 1px solid var(--surface-border);
}
.contact-summary-separator {
  color: var(--text-color-secondary);
}
.contact-summary-value {
  overflow-wrap: anywhere;
  color: var(--primary-color);
  font-weight: 600;
}
.contact-change-row + .contact-change-row {
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px solid var(--surface-border);
}
.contact-change-values {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  gap: 0.75rem;
  align-items: center;
  margin-top: 0.35rem;
}
.contact-change-old,
.contact-change-new {
  overflow-wrap: anywhere;
}
.contact-change-old {
  color: var(--text-color-secondary);
  text-decoration: line-through;
}
.contact-change-new {
  color: var(--primary-color);
  font-weight: 600;
}
</style>
